module.exports = __webpack_public_path__ + "img/concat.078205fd.png";